import { render } from "./assessment-desktop.vue?vue&type=template&id=4dc029e2&scoped=true&ts=true"
import script from "./assessment-desktop.vue?vue&type=script&lang=ts"
export * from "./assessment-desktop.vue?vue&type=script&lang=ts"

import "./assessment-desktop.vue?vue&type=style&index=0&id=4dc029e2&lang=scss&scoped=true"
import "./assessment-desktop.vue?vue&type=style&index=1&id=4dc029e2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc029e2"]])

export default __exports__